
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import BaseInput from './ui/BaseInput.vue';
import BaseCheckbox from './ui/BaseCheckbox.vue';
import SearchIcon from '../assets/icon/icon-search.svg';

interface FilterItem {
    name: string;
    count: number;
}

@Component({
    components: { BaseInput, BaseCheckbox }
})
export default class BrandFilter extends Vue {
    @Prop({ required: true }) readonly brands!: FilterItem[];
    @Prop({ required: true }) readonly value!: string[];

    SearchIcon = SearchIcon;
    searchQuery: string = '';
    selectedBrands: string[] = this.value;
    filteredBrands: FilterItem[] = this.brands;

    @Watch('value')
    onValueChange(newValue: string[]): void {
        this.selectedBrands = newValue;
    }

    @Watch('searchQuery')
    onSearchQueryChange(newQuery: string): void {
        this.filterBrands(newQuery);
    }

    @Watch('brands')
    onBrandsChange(): void {
        this.filterBrands(this.searchQuery);
    }

    filterBrands(query: string): void {
        if (query) {
            this.filteredBrands = this.brands.filter(brand =>
                brand.name.toLowerCase().includes(query.toLowerCase())
            );
        } else {
            this.filteredBrands = this.brands;
        }
    }

    emitChange(): void {
        this.$emit('input', this.selectedBrands);
    }

    onBrandChange(brandName: string, event: Event): void {
        const target = event.target as HTMLInputElement;
        if (target) {
            this.toggleBrand(brandName, target.checked);
        }
    }

    private toggleBrand(brandName: string, checked: boolean): void {
        if (checked) {
            this.selectedBrands.push(brandName);
        } else {
            const index = this.selectedBrands.indexOf(brandName);
            if (index !== -1) {
                this.selectedBrands.splice(index, 1);
            }
        }
        this.emitChange();
    }
}
